import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    // Ajouter listener pour fermer au scroll (mobile only)
    this.handleScroll = this.closeOnScroll.bind(this)
    window.addEventListener('scroll', this.handleScroll, { passive: true })

    // Fermer au click ailleurs
    this.handleClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener('click', this.handleClickOutside)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    // Toggle la classe show sur mobile ET desktop
    const isOpen = this.contentTarget.classList.contains("show")

    if (!isOpen) {
      // Fermer les autres tooltips ouverts
      document.querySelectorAll('.tooltip-content.show').forEach(tooltip => {
        tooltip.classList.remove('show')
      })

      // Reset transform before showing
      this.contentTarget.style.transform = ''

      this.contentTarget.classList.add("show")

      // Ajuster position sur mobile pour éviter overflow
      requestAnimationFrame(() => this.adjustPositionMobile())
    } else {
      this.contentTarget.classList.remove("show")
    }
  }

  adjustPositionMobile() {
    if (window.innerWidth > 640) return // Desktop only uses CSS

    const rect = this.contentTarget.getBoundingClientRect()
    const windowWidth = window.innerWidth
    const tooltipWidth = rect.width

    // Calculate ideal centered position
    const idealLeft = rect.left + rect.width / 2 - tooltipWidth / 2

    let adjustedLeft = idealLeft

    // Keep within bounds with 10px margin
    if (adjustedLeft < 10) {
      adjustedLeft = 10
    } else if (adjustedLeft + tooltipWidth > windowWidth - 10) {
      adjustedLeft = windowWidth - tooltipWidth - 10
    }

    // Calculate offset from current centered position
    const offset = adjustedLeft - idealLeft

    // Apply adjustment while keeping base centering
    if (offset !== 0) {
      this.contentTarget.style.transform = `translateX(calc(-50% + ${offset}px))`
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.contentTarget.classList.remove("show")
  }

  closeOnScroll() {
    // Fermer seulement sur mobile
    if (window.innerWidth <= 640 && this.contentTarget.classList.contains("show")) {
      this.contentTarget.classList.remove("show")
    }
  }

  closeOnClickOutside(event) {
    // Fermer si ouvert (mobile et desktop)
    if (this.contentTarget.classList.contains("show")) {
      // Si le click n'est pas dans le wrapper du tooltip
      if (!this.element.contains(event.target)) {
        this.contentTarget.classList.remove("show")
      }
    }
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClickOutside)
    this.contentTarget.classList.remove("show")
  }
}